import { createMachine } from 'xstate'
import {
  buildOptions,
  setOptions,
  setSelectedPrice,
  setOrderUrl,
  calculateDiscount,
} from './actions'

const machineConfig = {
  id: 'product-page-machine',
  initial: 'initial',
  context: {
    locale: 'en-GB',
    currency: 'GBP',
    options: [],
    product: {},
    orderButtonText: '',
    checkboxes: false,
    hasMultiplePrices: false,
  },
  states: {
    initial: {
      entry: ['buildOptions', 'setSelectedPrice', 'calculateDiscount', 'setOrderUrl'],
      on: {
        SELECT_OPTION: {
          target: 'optionSelected',
        },
        ORDER: {
          target: 'ordering',
        },
      },
      always: [
        {
          target: 'nothingSelected',
          cond: {
            type: 'nothingSelected',
          },
        },
      ],
    },
    optionSelected: {
      entry: ['setOptions', 'setSelectedPrice', 'calculateDiscount', 'setOrderUrl'],
      on: {
        SELECT_OPTION: {
          target: 'optionSelected',
        },
        ORDER: {
          target: 'ordering',
        },
      },
      always: [
        {
          target: 'nothingSelected',
          cond: {
            type: 'nothingSelected',
          },
        },
      ],
    },
    nothingSelected: {
      on: {
        SELECT_OPTION: {
          target: 'optionSelected',
        },
      },
    },
    ordering: {
      entry: ['navigateToOrder'],
      type: 'final',
    },
  },
}

const actions = {
  buildOptions,
  setOptions,
  setSelectedPrice,
  setOrderUrl,
  calculateDiscount,
}

const guards = {
  nothingSelected: (ctx) => ctx.options.every((option) => !option.checked),
}

export default createMachine(machineConfig, {
  actions,
  guards,
})
